module.exports = __webpack_public_path__ + "assets/img/键盘亮度.8eefa12f.png";